import React from 'react';
import Modal from './Modal';
import Button from './Button';

const WeekChangeConfirmationModal = ({
    isOpen,
    onClose,
    onConfirm,
    scheduleItem,
    currentWeekNumber,
    currentYear
}) => {
    if (!scheduleItem) {
        return null;
    }

    // Check if this is a multi-week item
    const isMultiWeek = scheduleItem.weekSeries && scheduleItem.weekSeries.trim() !== '';

    // If not multi-week, don't show the modal
    if (!isMultiWeek) {
        return null;
    }

    const handleThisEventOnly = () => {
        onConfirm('thisWeekOnly');
    };

    const handleAllEvents = () => {
        onConfirm('allWeeks');
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Edit recurring event"
        >
            <div className="space-y-6">
                <div className="text-gray-700">
                    <p className="mb-2">
                        <strong>"{scheduleItem.displayName}"</strong> occurs across multiple weeks (weeks {scheduleItem.weekSeries}).
                    </p>
                    <p className="text-sm text-gray-600">
                        Would you like to edit just this occurrence or all occurrences?
                    </p>
                </div>

                <div className="space-y-3">
                    {/* This Event Option */}
                    <button
                        onClick={handleThisEventOnly}
                        className="w-full p-4 text-left border border-gray-200 rounded-lg hover:border-blue-300 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                    >
                        <div className="flex items-center justify-between">
                            <div>
                                <h4 className="font-medium text-gray-900">This event</h4>
                                <p className="text-sm text-gray-600 mt-1">
                                    Only edit this week (week {currentWeekNumber})
                                </p>
                            </div>
                            <div className="w-4 h-4 border-2 border-gray-300 rounded-full"></div>
                        </div>
                    </button>

                    {/* All Events Option */}
                    <button
                        onClick={handleAllEvents}
                        className="w-full p-4 text-left border border-gray-200 rounded-lg hover:border-green-300 hover:bg-green-50 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors"
                    >
                        <div className="flex items-center justify-between">
                            <div>
                                <h4 className="font-medium text-gray-900">All events</h4>
                                <p className="text-sm text-gray-600 mt-1">
                                    Edit all occurrences across weeks {scheduleItem.weekSeries}
                                </p>
                            </div>
                            <div className="w-4 h-4 border-2 border-gray-300 rounded-full"></div>
                        </div>
                    </button>
                </div>

                <div className="flex justify-end pt-4 border-t border-gray-200">
                    <Button
                        variant="secondary"
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default WeekChangeConfirmationModal; 